<template>
    <nav>
        <div id="logo" @click="$router.push({ path: '/' })">
            <img src="@/assets/img/cardicon-small.png" />
            <h1>EDH and other Bullshit</h1>
        </div>
        <div id="links">
            <!-- <router-link to="/" class="link">Home</router-link> -->
            <template v-for="tier in tiers" :key="tier.slug">
                <router-link :to="{ name: 'Tier', params: { slug: tier.slug } }" class="link">{{
                    tier.name
                }}</router-link>
            </template>
        </div>
    </nav>
    <main>
        <router-view />
    </main>
</template>

<script>
import { gql } from 'graphql-request';

export default {
    data() {
        return {
            tiers: [],
        };
    },
    async created() {
        const data = await this.$graphcms.request(
            gql`
                {
                    tiers(orderBy: name_ASC) {
                        name
                        slug
                    }
                }
            `
        );

        this.errors = data.errors;
        this.loading = false;
        this.tiers = data.tiers;
    },
};
</script>

<style lang="scss">
@import './styles/style.scss';

$navbar-height: 60px;

#app {
    height: 100%;
    width: 100%;

    nav {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: $navbar-height;
        z-index: 1;
        overflow-y: hidden;

        // background: transparent;
        // background-image: url('assets/img/wallpaper-zendikar.png');
        background: $color-primary;
        border-bottom: solid 2px $color-navbar;
        border-radius: ($navbar-height / 2);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        -webkit-user-select: none !important;
        -webkit-touch-callout: none !important;
        user-select: none;

        @media (min-width: 0px) {
            margin: 1rem 2rem 0 2rem;
            padding: 0 1rem;
            justify-content: center;
        }

        @media (min-width: 770px) {
            margin: 1rem 4rem 0 4rem;
            padding: 0 3rem;
            justify-content: space-between;
        }

        #logo {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 6px;

            @media (min-width: 0px) {
                display: none;
            }

            @media (min-width: 770px) {
                display: flex;
            }

            h1 {
                font-family: 'Permanent Marker', cursive;
                color: $color-text-light;
                font-weight: 300;

                @media (min-width: 770px) {
                    display: block;
                    font-size: 1.3rem;
                    white-space: nowrap;
                    overflow: hidden;
                }

                @media (min-width: 1000px) {
                    font-size: 2rem;
                }
            }

            &:hover {
                text-decoration: $color-text-light underline;
                text-underline-offset: 7px;
                text-decoration-thickness: 3px;
            }
        }

        #links {
            height: $navbar-height;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 1rem;

            .link {
                font-size: 1.2rem;
                color: $color-text-light;
                line-height: 100%;
                border-radius: 18px;
                padding: 8px 12px;
                height: 36px;
                // height: 100%;
                // border: 2px solid transparent;

                &.router-link-exact-active {
                    color: $color-primary;
                    background-color: $color-background;
                }

                &:hover {
                    &:not(.router-link-exact-active) {
                        //color: $color-secondary;
                        // border-radius: 0;
                        // border-bottom: 2px solid $color-text-light;
                        text-decoration: $color-text-light underline;
                        text-underline-offset: 7px;
                        text-decoration-thickness: 3px;
                    }
                }
            }
        }
    }

    main {
        height: 100%;
        //padding: 16px;
        // padding-top: ($navbar-height + 16px);
        padding-top: ($navbar-height + 16px);
        overflow: auto;
    }
}
</style>
